import { tsValidateArray, tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { smartDocStaticParamType_SmartMDM } from './types.js';
import { Validator_SmartDocStaticParamType } from '../_base/index.js';
import { Validator_SmartDocParamResolver_MDM } from '../../../smart-doc-param-resolver/index.js';
import { smartDocStaticParamType_MDM_ConsiderationGroups, smartDocStaticParamType_MDM_ProtocolStatus, smartDocStaticParamType_MDM_ProtocolTypes } from '../mdm/index.js';
export const Validator_SmartDocStaticParam_SmartMDM = {
    key: tsValidateString(),
    type: Validator_SmartDocStaticParamType,
    subType: tsValidateValue([smartDocStaticParamType_SmartMDM]),
    protocolType: tsValidateArray(tsValidateValue([...smartDocStaticParamType_MDM_ProtocolTypes])),
    protocolConsiderationGroup: tsValidateArray(tsValidateValue([...smartDocStaticParamType_MDM_ConsiderationGroups])),
    protocolStatus: tsValidateArray(tsValidateValue([...smartDocStaticParamType_MDM_ProtocolStatus])),
    resolver: Validator_SmartDocParamResolver_MDM,
};
//# sourceMappingURL=validator.js.map